import { makeStyles, TextField } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import Autocomplete from '@material-ui/lab/Autocomplete';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
    inputEl: {
        width: '100%',
    },
    optionItem: {
        padding: 0,
    },
    noOptionLabel: {
        color: theme.color.font.dark,
    },
}));
const AutocompleteSelectInput = (props) => {
    const { options, loading, label, placeholder, selectedValue, onInputChangeCb, onResetCb, testId = 'AutocompleteSelectInput', onSelectCb, CustomInputEl, ...rest } = props;
    const classes = useStyles();
    const [open, setOpen] = React.useState(false);
    const [value, setValue] = React.useState(selectedValue || null);
    const [inputValue, setInputValue] = React.useState('');
    return (React.createElement(Autocomplete, Object.assign({ "data-testid": `${testId}`, style: { width: '100%' }, classes: { option: classes.optionItem, noOptions: classes.noOptionLabel }, open: open, onOpen: () => {
            setOpen(true);
        }, onClose: () => {
            setOpen(false);
        }, value: value, onChange: (_, newValue) => {
            if (onSelectCb) {
                onSelectCb(newValue);
            }
            setValue(newValue);
        }, inputValue: inputValue, onInputChange: (_, newInputValue, reason) => {
            if (onResetCb && reason === 'clear') {
                onResetCb();
            }
            if (onInputChangeCb) {
                onInputChangeCb(newInputValue);
            }
            setInputValue(newInputValue);
        }, getOptionSelected: (option, value) => option.name === value.name, getOptionLabel: (option) => option.name, options: options, loading: loading, renderInput: (params) => CustomInputEl || (React.createElement(TextField, Object.assign({}, params, { "data-testid": `${testId}-input`, className: classes.inputEl, label: label, placeholder: placeholder, InputProps: {
                ...params.InputProps,
                endAdornment: (React.createElement(React.Fragment, null,
                    loading ? React.createElement(CircularProgress, { color: "inherit", size: 20 }) : null,
                    params.InputProps.endAdornment)),
            } }))) }, rest)));
};
export default AutocompleteSelectInput;
//# sourceMappingURL=AutocompleteSelectInput.js.map